//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Flag = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Flag"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.8 2.29875H12.4996L11.4926 4.56463C11.2282 5.15933 11.2282 5.83817 11.4926 6.43287L12.4996 8.69875H2.8V2.29875ZM2.8 0.998749H13.0774H14.5L13.9222 2.29875L12.6805 5.09261C12.5656 5.35118 12.5656 5.64632 12.6805 5.90489L13.9222 8.69875L14.5 9.99875H13.0774H2.8L2.8 14.9987H1.5V9.99875V8.69875V2.29875V0.998749H2.8Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
